<template>
  <div v-if="$userInfo">
    <div class="columns is-gapless">
      <div v-show="showfilter"
        class="column is-narrow">
        <error-log-list-side-menu v-model="filter"
          @filter="loadErrorLogDetail"
          @reset="resetList" />
      </div>
      <div class="column">
        <error-log-detail
          v-model="selectedErrorLog" />
      </div>
    </div>
  </div>

</template>

<script>
import { Columns } from './columns'
import ErrorLogService from './ErrorLogService'
import ErrorLogListSideMenu from './ErrorLogListSideMenu.vue'
import ErrorLogDetail from './ErrorLogDetail.vue'

export default {
  name: 'ErrorLogList',
  components: {
    ErrorLogListSideMenu,
    ErrorLogDetail
  },
  props: {
    hideFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isTableLoading: false,
      totalRows: 0,
      selectedRow: null,
      filter: {
        sortColumn: Columns[0].name,
        sortOrder: Columns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 18,
        eventId: null
      },
      eventId: '',
      showfilter: true,
      selectedErrorLog: null
    }
  },
  computed: {
    columns() {
      return Columns
    },
    filterKey() {
      if (this.$userInfo) {
        return `${this.$userInfo.sessionId}|${this.$route.meta.fkey}|ErrorLog`
      } else {
        return ''
      }
    }
  },
  watch: {
    eventId: {
      handler: function (newVal, oldVal) {
        this.filter.eventId = newVal
      },
      deep: true
    },
    hideFilter: {
      handler: function (newVal, oldVal) {
        this.showfilter = !newVal
      },
      deep: true
    }
  },
  created() {
    if (!this.filter.eventId) {
      if (this.$route.params.eventId) {
        this.filter.eventId = this.$route.params.eventId
      }
    }
    this.persistFilter()
    this.showfilter = !this.hideFilter
    this.loadErrorLogDetail()
  },
  methods: {
    async loadErrorLogDetail() {
      this.$showSpinner('Loading error log...')
      try
      {
        this.selectedErrorLog = null
        const logId = this.filter.eventId
        if (logId) {
          const fullErrorLog = await ErrorLogService.getLog(logId)
          if (fullErrorLog && !!(fullErrorLog.eventId)) {
            this.selectedErrorLog = fullErrorLog
          }
        }
      }
      catch (error)
      {
        this.selectedErrorLog = null
      }
      this.$hideSpinner()
    },
    resetList() {
      this.filter.eventId = null
      this.filter.sortColumn = Columns[0].name
      this.filter.sortOrder = Columns[0].defaultOrder
      this.filter.pageIndex = 1
      this.filter.pageSize = 18
      this.persistFilter()
      this.loadErrorLogDetail()
    },
    persistFilter() {
      sessionStorage.setItem(this.filterKey, JSON.stringify(this.filter))
    }
  }
}
</script>

<style scoped>

</style>